export enum Breakpoint {
  Tablet = "600px",
  Medium = "960px",
  Large = "1280px",
  Wide = "1700px",
}
